import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFullScreen = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.7 9.3L1.5 14.5M5.4 14.5H1.5V10.6M10.6 1.5H14.5V5.4M14.5 1.5L9.3 6.7",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgFullScreen;
